import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {UserInfoStorageService} from './user-info-storage.service';
import {CrystalClearFrontUrl} from '../../shared/pages/crystal-clear-front-url';
import {RoutingData} from '../../routing/routing-data';

@Injectable({providedIn: 'root'})
export class IsNotLoggedPageGuard implements CanActivate {
  constructor(protected router: Router, protected authService: UserInfoStorageService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    if (this.authService.isAuthenticated) {
      if (route.queryParamMap.get('token')) {
        this.authService.logout();
        return true;
      }
      this.authService.refreshConnectedUserCacheInfo().subscribe(user => {
        let redirectTo = route.queryParams[RoutingData.Extras.REDIRECT_TO];
        if (!redirectTo) {
          redirectTo = CrystalClearFrontUrl.HOME.path;
        }
        this.router.navigateByUrl(redirectTo);
      });
    }
    return true;
  }
}
